<div style="flex: 1 1 100%; flex-direction: column;display: flex;">
  <mat-slide-toggle class="mt-3" [checked]="value" (change)="toggleChange($event)" style="flex: 1 1 100%;">
    <ng-container *ngIf="!value">{{ 'tasker.geo-input.set-position' | translate }}</ng-container>
    <ng-container *ngIf="value">{{ 'tasker.geo-input.position' | translate }}: {{ value.address }}</ng-container>
  </mat-slide-toggle>
</div>
